import styled from '@mui/material/styles/styled.js'

// NOTE: Elements in this file are intended to make standard DOM elements easy
// to style with MUI's sx prop.
// @see: https://mui.com/system/styled/
// @see: https://mui.com/system/getting-started/the-sx-prop/

export const Span = styled('span')({})
